import React, { useEffect, useCallback, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import Collapse from '@material-ui/core/Collapse';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CircularProgress } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { isUndefined, isEmpty, isNull } from 'lodash';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';

import EditLiveContent from '../EditLiveContent';
import { uploadContentService } from '../../services';

import { useHistory } from 'react-router-dom';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#252525",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 12,
    color: theme.palette.common.white,
    width: "50%"
  },
  button: {
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: "#424242",
      height: "140px"
    },
    '&:nth-of-type(even)': {
      backgroundColor: "#252525",
      height: "140px"
    },
  },
}))(TableRow);

function createData(SPILLELISTER, BUTTON) {
  return { SPILLELISTER, BUTTON };
}

const useStyles = makeStyles({
  table: {
    minWidth: 700
  },
  button: {
    marginTop: 10,
    height: 40,
    width: 80,
    float: 'right',
    fontSize: 15,
    fontWeight: 'bold',
    color: '#ffffff',
    backgroundColor: '#6C6C6C'
  },
  cellGreen: {
    backgroundColor: 'green',
    width: "100%",
    marginTop: '10px',
    // minHeight: 15,
    // margin: 5,
  },
  cellRed: {
    backgroundColor: 'red',
    width: '100%',
    marginTop: '10px',
  },
  tableHeaderCell: {
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  nested: {
    paddingLeft: "32px",
    minHeight: 40,
    minWidth: 10,
    marginBottom: "10px"
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2rem 0',
  },
  listItemIcon: {
    color: "darkorange",
  },
  unitNameText: {
    width: "505px"
  },
  firstItemList: {
    marginBottom: "10px"
  },
  dynamicRowCell: {
    width: "400px"
  },
  headerItemsText: {
    color: 'white',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '13px',
    top: 55,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#252525'
  },
  subHeader: {
    backgroundColor: "#252525",
  },
  '@global': {
    '[class^=makeStyles-headerItemsText-]': {
      borderBottomColor: '#252525'
    }
  }
});

export default function CustomizedTables() {
  const classes = useStyles();
  const history = useHistory();

  const [tagHeaderContent, setTagHeaderContent] = useState([]);
  const [taggedContentUnitList, setTaggedContentUnitList] = useState([]);
  const [tableHeaderItems, setTableHeaderItems] = useState([]);

  const [totalUnits, setTotalUnits] = useState(null);

  const [openUnit1, setOpenUnit1] = useState(false);
  const [openUnit2, setOpenUnit2] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [expandItemNumber, setExpandItemNumber] = useState(null);
  const { user } = useSelector(state => state.userAuthentication);

  const handleOpenUnit1 = (event) => {
    const index = parseInt(event.currentTarget.dataset.index);
    if (index === expandItemNumber) {
      setExpandItemNumber(index);
      setOpenUnit1(!openUnit1);
    }
    else {
      setOpenUnit1(!openUnit1);
      setExpandItemNumber(index);
      setOpenUnit1(true);
    }
  };

  const handleOpenUnit2 = () => {
    setOpenUnit2(!openUnit2);
  };

  const handleRedirectToPage = (event) => {
    if (event.currentTarget.dataset.value === "tagged-playlist-detail") {
      history.push({
        pathname: '/tagged-playlist-detail',
        state: { id: event.currentTarget.dataset.id }
      });
      window.location.reload();
    }
  }

  const mainProcess = useCallback(async () => {
    let devices = await getTaggedContentUnitList();
    let playlist = await getTaggedPlaylist();
    let content = await getContent();
    if (devices.length > 0 && playlist.length > 0)
      combineDevicePlaylist(devices, playlist, content);
    if (devices.length > 0) {
      dynamicTableHeaderItems(devices);
    }
  }, [user]);

  const combineDevicePlaylist = (devices, playlist, content) => {
    let newDevices = [];
    let presentationListPlaylist = groupPlaylistByPresentation(playlist);
    devices.map((item, index) => {
      if (item.presentation !== null) {
        let selectedPlaylist = presentationListPlaylist.filter(x => x.id === item.presentation.id)[0];
        if (selectedPlaylist === undefined)
          item.playlist = [];
        else {
          let newPlaylist = selectedPlaylist.playlist;
          if (content.length > 0) {
            newPlaylist = crossmatchContentTaggedPlaylist(content, newPlaylist);
            item.contentName = content[0].fileName;
          }
          item.playlist = newPlaylist;
        }
        newDevices.push(item);
      }
    })
    setTaggedContentUnitList(newDevices);
    setTotalUnits(newDevices.length);
  }

  const crossmatchContentTaggedPlaylist = (content, playlist) => {
    let newPlaylist = [];
    content.map(contentInfo => {
      contentInfo.taggedPlaylists.map(taggedPlaylist => {
        playlist.map(itemPlaylist => {
          if (itemPlaylist.id === taggedPlaylist.id)
            itemPlaylist.isMatch = true;
          else {
            if (itemPlaylist.isMatch === false)
              itemPlaylist.isMatch = false;
          }
          let index = newPlaylist.findIndex(x => x.id === itemPlaylist.id);
          if (index === -1)
            newPlaylist.push(itemPlaylist);
        });
      });
    })

    return newPlaylist;
  }

  const groupPlaylistByPresentation = (playlist) => {
    let presentationListPlaylist = [];
    playlist.map(itemPlaylist => {
      if (isNull(itemPlaylist.presentations))
        return;
      itemPlaylist.presentations.map(itemPresentation => {
        if (presentationListPlaylist.filter(item => item.id === itemPresentation.id).length === 0
          || presentationListPlaylist.length === 0) {
          let presentationPlaylist = {
            id: itemPresentation.id,
            name: itemPresentation.name,
            type: itemPresentation.type,
            playlist: []
          }
          presentationPlaylist.playlist.push({
            id: itemPlaylist.id,
            name: itemPlaylist.name,
            physicalPath: itemPlaylist.physicalPath,
            contentsVirtualPath: itemPlaylist.contentsVirtualPath,
            rule: itemPlaylist.rule,
            orderTag: itemPlaylist.orderTag,
            ttl: itemPlaylist.ttl,
            waitingForApprove: itemPlaylist.waitingForApprove,
            creationDate: itemPlaylist.creationDate,
            content: itemPlaylist.content
          });
          presentationListPlaylist.push(presentationPlaylist);
        }
        else {
          let presentationPlaylist = presentationListPlaylist.filter(x => x.id === itemPresentation.id)[0];
          let newPresentationList = presentationListPlaylist.filter(x => x.id !== itemPresentation.id)
          if (isUndefined(presentationPlaylist.playlist))
            presentationPlaylist.playlist = [];
          if (presentationPlaylist.playlist.some(item => item.id !== itemPlaylist.id)) {
            presentationPlaylist.playlist.push({
              id: itemPlaylist.id,
              name: itemPlaylist.name,
              physicalPath: itemPlaylist.physicalPath,
              contentsVirtualPath: itemPlaylist.contentsVirtualPath,
              rule: itemPlaylist.rule,
              orderTag: itemPlaylist.orderTag,
              ttl: itemPlaylist.ttl,
              waitingForApprove: itemPlaylist.waitingForApprove,
              creationDate: itemPlaylist.creationDate,
              content: itemPlaylist.content
            });
            newPresentationList.push(presentationPlaylist);
          }

          presentationListPlaylist = newPresentationList;
        }

      });
    });
    return presentationListPlaylist;
  }

  const getTaggedContentUnitList = async () => {
    if (!isUndefined(user)) {
      const marker = '';
      var devices = [];
      const recursiveFunc = async (marker) => {
        var res = await uploadContentService.taggedContentUnitList(user, marker);
        if (!isUndefined(res)) {
          if (!isUndefined(res?.devices)) {
            devices.push.apply(devices, res?.devices);
          }
          if (res.isTruncated) {
            await recursiveFunc(res.nextMarker);
          }
        }
      }
      await recursiveFunc(marker);
      return devices;
    }
  }

  const getTaggedPlaylist = async () => {
    if (!isUndefined(user)) {
      const marker = '';
      var playlist = [];
      const recursiveFunc = async (marker) => {
        const res = await uploadContentService.taggedPlaylists(user, marker);
        if (!isUndefined(res)) {
          if (!isUndefined(res?.items)) {
            playlist.push.apply(playlist, res?.items);
          }
          if (res.isTruncated) {
            await recursiveFunc(res.nextMarker);
          }
        }
      }
      await recursiveFunc(marker);
      return playlist;
    }
  }

  const getContent = async () => {
    if (!isUndefined(user)) {
      const marker = '';
      var content = [];
      const recursiveFunc = async (marker) => {
        const res = await uploadContentService.uploadContent(user, marker);
        if (!isUndefined(res)) {
          if (!isUndefined(res?.items)) {
            let newItems = res.items.filter(x => x.mediaType !== 'Folder')
            content.push.apply(content, newItems);
          }
          if (res.isTruncated) {
            await recursiveFunc(res.nextMarker);
          }
        }
      }
      await recursiveFunc(marker);
      return content;
    }
  }

  useEffect(() => {
    mainProcess();
  }, []);

  const fetchMoreData = () => {
    if (!isUndefined(taggedContentUnitList) && !isNull(taggedContentUnitList) && !isUndefined(totalUnits) & !isNull(totalUnits)) {
      if (taggedContentUnitList.length >= totalUnits) {
        setHasMore(false);
        return;
      }

      // a fake async api call like which sends
      // more records in .5 secs
      setTimeout(() => {
        setTaggedContentUnitList([...taggedContentUnitList].concat(taggedContentUnitList));
      }, 500);
    }
  }

  const dynamicTableHeaderItems = (devices) => {
    if (!isNull(devices) && !isUndefined(devices) && !isEmpty(devices)) {
      let newDevices = devices;
      let headers = [];
      let headerItems = [];
      headers.push('devices');
      devices.map((itemDevices, indexDevices) => {
        if (!isNull(itemDevices.tags) && !isEmpty(itemDevices.tags) && !isUndefined(itemDevices.tags)) {
          [...itemDevices.tags].map((item, index) => {
            if (item.length > 0) {
              let newItem = item.map(x => x.replace(/['}]/g, ''));
              let regionIndex = newItem.indexOf('<region>');
              if (regionIndex === -1)
                regionIndex = newItem.indexOf('<Region>')
              if (regionIndex > - 1) {
                let value = newItem[regionIndex + 1];
                let headerItemsIndexCheck = headerItems.indexOf(value);
                if (headerItemsIndexCheck === -1) {
                  headerItems.push(value);
                }
                newDevices[indexDevices].tagsStr = value;
                let hasRegion = headers.indexOf('region');
                if (hasRegion < 0) {
                  headers.push('region');
                  setTagHeaderContent(headers);
                }
              }
            }

            return;
          });
        }
      })
      setTableHeaderItems(headerItems)
      setTaggedContentUnitList(newDevices);
      setTotalUnits(newDevices.length);
    }
  }

  return (
    <div>
      <span className="span-design">
        <div className="icon-design"><LocalOfferIcon /> Tagged </div>
        <h3 className="text-design">  Content</h3>
      </span>
      <TableContainer component={Paper} >
        <Table stickyHeader className={classes.table} aria-label="customized table">
          <InfiniteScroll
            dataLength={taggedContentUnitList.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={<h4>Loading data...</h4>}
            height={850}
            style={{ height: '72vh', overflowY: 'auto', backgroundColor: '#252525' }}
          >
            <TableHead>
              {!isUndefined(taggedContentUnitList) && !isNull(taggedContentUnitList) && !isUndefined(tagHeaderContent) ? (
                <TableRow>
                  {tagHeaderContent.map(item => (
                    <StyledTableCell className={classes.tableHeaderCell} onClick={() => {
                      if (item === 'region') {
                        handleOpenUnit2();
                      }
                    }}>{item === 'region' && (openUnit2 ? <RemoveCircleIcon /> : <AddCircleIcon />)}{item}</StyledTableCell>
                  ))}

                  {
                    tableHeaderItems.map((item, indexHeaders) => (
                      (indexHeaders > 0) ?
                        <StyledTableCell className={classes.tableHeaderCell}></StyledTableCell>
                        : ""
                    ))
                  }
                </TableRow>
              ) : ""}
            </TableHead>
            <TableHead>
              {!isUndefined(taggedContentUnitList) && !isNull(taggedContentUnitList) && !isUndefined(tagHeaderContent) ? (
                <TableRow>

                </TableRow>
              ) : ""}
            </TableHead>

            <TableRow className={classes.subHeader}>
              <StyledTableCell className={classes.headerItemsText}>{isUndefined(taggedContentUnitList[0]) ? "" : taggedContentUnitList[0].contentName}</StyledTableCell>
              {
                openUnit2 && tableHeaderItems.length > 0 ? (
                  tableHeaderItems.map(item => (
                    <StyledTableCell className={classes.headerItemsText}>{item}</StyledTableCell>
                  ))
                ) : ""
              }

            </TableRow>

            <TableBody>
              {!isUndefined(taggedContentUnitList) && !isNull(taggedContentUnitList) && !isUndefined(hasMore) && !isNull(hasMore) ? (
                [...taggedContentUnitList].map((item, index) => (
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      <List component="nav" aria-labelledby="nested-list-subheader">
                        <ListItem className={classes.firstItemList} data-index={index} onClick={handleOpenUnit1}>
                          <ListItemIcon className={classes.listItemIcon}>
                            <VideoLabelIcon />
                          </ListItemIcon>
                          <ListItemText className={classes.unitNameText} primary={item.name} />
                          {!isUndefined(item.playlist) && !isNull(item.playlist) &&
                            <div>
                              {
                                item.playlist.length > 0 &&
                                <div>
                                  {(openUnit1 && expandItemNumber === index) ? <ExpandLess /> : <ExpandMore />}
                                </div>
                              }
                            </div>
                          }
                        </ListItem>
                        {!isUndefined(item.playlist) && !isNull(item.playlist) &&
                          <div>
                            {
                              item.playlist.map((itemPlaylist, indexPlaylist) => (
                                <Collapse in={expandItemNumber === index ? openUnit1 : false} timeout="auto" unmountOnExit>
                                  <List component="div" disablePadding>
                                    <ListItem className={classes.nested} style={{ marginTop: indexPlaylist === 0 ? '20px' : '10px' }}>
                                      <ListItemIcon className={classes.listItemIcon}>
                                        <LocalOfferIcon />
                                      </ListItemIcon>
                                      <ListItemText primary={itemPlaylist.name} />
                                    </ListItem>
                                  </List>
                                </Collapse>
                              ))
                            }
                          </div>
                        }
                      </List>
                    </StyledTableCell>
                    {tableHeaderItems.map(itemHeaderItems => (
                      <StyledTableCell align="right">
                        <List className={classes.dynamicRowCell} component="nav" aria-labelledby="nested-list-subheader">
                          <ListItem className={classes.firstItemList}>
                            {openUnit1 && expandItemNumber === index ? <ExpandLess style={{ visibility: "hidden" }} /> : <ExpandMore style={{ visibility: "hidden" }} />}
                          </ListItem>
                          {itemHeaderItems === item.tagsStr && openUnit2 &&
                            <div style={{ marginTop: '80px' }}>
                              {
                                item.playlist.map((itemPlaylist, indexPlaylist) => (
                                  <Collapse in={expandItemNumber === index ? openUnit1 : false} timeout="auto" unmountOnExit>
                                    <List className={itemPlaylist.isMatch === true ? classes.cellGreen : classes.cellRed} 
                                    component="div" disablePadding 
                                    style={{ marginTop: indexPlaylist === 0 ? '-40px' : '13px' }}>
                                      <ListItem className={classes.nested}>
                                        <ListItemText primary="" />
                                      </ListItem>
                                    </List>
                                  </Collapse>
                                ))
                              }
                            </div>
                          }
                        </List>
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))
              ) : (
                <div className={classes.loader}>
                  <CircularProgress />
                </div>
              )}
            </TableBody>
          </InfiniteScroll>
        </Table>
      </TableContainer>
    </div >
  );
}